import { useCurrentPSAPAccountID } from '@rsos/reduxDataStore/src/features/capstone/psapInfo';
import { getGmrLandingZoneAdminUrlTemplate } from '@rsos/utils/metaTags';
import { buildLandingZonesUrl } from './buildLandingZonesUrl';

export interface LandingZonesUrlResult {
  /** Resolved iframe src, or '' when the template or account id is missing. */
  url: string;
  /** Raw configured template, still containing its {account_id} token. */
  template: string;
  /** The current authority's account id, if it has one. */
  accountId: string | undefined;
}

/**
 * Resolves the Landing Zone tool iframe src from Hydra config plus the current
 * authority.
 *
 * `template` and `accountId` come back alongside `url` so the caller can tell
 * "not configured in this environment" apart from "this authority has no
 * account_id" — two very different things to put in front of an admin.
 *
 * Safe to call unconditionally: psapInfoSlice initialises currentPSAP to {},
 * and SectionGate only renders children once initialize() (which awaits
 * fetchPsap) has fulfilled.
 */
const useLandingZonesUrl = (): LandingZonesUrlResult => {
  const accountId = useCurrentPSAPAccountID();
  const template = getGmrLandingZoneAdminUrlTemplate() || '';

  return {
    url: buildLandingZonesUrl(template, accountId),
    template,
    accountId,
  };
};

export default useLandingZonesUrl;
